document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.evergreen-subscribe.sticky');
  const mainContent = document.querySelector('#main-content');
  const footer = document.querySelector('.page-footer');
  if (!banner || !mainContent || !footer) return;

  let mainAtTop = false;
  let footerInView = false;

  const update = () => {
    if (mainAtTop && !footerInView) {
      banner.classList.add('is-visible');
    } else {
      banner.classList.remove('is-visible');
    }
  };

  // Trigger when #main-content top hits the top of the viewport
  const showObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        // intersecting == top at/above top edge due to rootMargin
        mainAtTop = entry.isIntersecting;
        update();
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -100% 0px' // top of #main-content at top of viewport
    }
  );
  showObserver.observe(mainContent);

  // Hide as soon as ANY part of the footer enters the viewport
  const hideObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        footerInView = entry.isIntersecting; // true when footer touches viewport at all
        update();
      });
    },
    {
      root: null,
      threshold: 0,  // fire on first pixel entering
      rootMargin: '0px' // no offset: "as soon as it enters"
    }
  );
  hideObserver.observe(footer);

  // start hidden
  banner.classList.remove('is-visible');
});
